import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./features/App.tsx";
import "../vendor/cm-chessboard/assets/chessboard.css";
import "../vendor/cm-chessboard/assets/extensions/promotion-dialog/promotion-dialog.css";
import "../css/styles.css";
import "./features/app.css";
import "./features/report-card.css";
import "./features/boards.css";
import "./features/themes.css";
import "./features/appearance.css";
import "./features/trainer-interface.css";
import "./features/phone.css";
import "./features/openings.css";
import { applyAppearance, getAppearance } from "./appearance/appearance.ts";
import { ErrorBoundary } from "./features/layout/ErrorBoundary.tsx";
import { registerOffline } from "./offline.ts";

// Apply the saved appearance before the first paint so nothing flashes.
applyAppearance(getAppearance());
registerOffline();

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary
      fallback={
        <main className="app-crash" role="alert">
          <h1>Something went wrong.</h1>
          <p>Reload the page to continue. Your saved progress is kept.</p>
          <button className="btn-primary" type="button" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </main>
      }
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
